import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { Radio, Divider, Form, Input, message, Button, TimePicker, DatePicker,Select,Space } from "antd";
import moment from 'moment'
import TextArea from "antd/es/input/TextArea";
import CandidateAddModal from "../../components/CandidateAddModal";

import useCandidateStore from "../../store/candidateModal.store";
import useJobApplicationStore from "../../store/jobapplication.store";
import useJDStore from "../../store/jd.store";

import "./jobApplicationForm.scss";



export default function JobApplicationForm() {
    const [currentView, setCurrentView] = useState("profile");
    const [isEditMode, setIsEditMode] = useState(true);
    const { qhoid,jdID, resumeID } = useParams();

    const [formKey, setFormKey] = useState(1);
    const [isRequired, setIsRequired] = useState(true);
    const [haveOtherOffer, setOffersGot] = useState(false);

    const { setCandidateModalOpen } = useCandidateStore();
    
    const { linkedApplicationError, linkedJd,getLinkedProfileResumeDetails,linkedProfileResume, getLinkedApplicationByJD,linkedApplication,updateProfileInLinkedApplication} =
          useJobApplicationStore();

    var value = jdID;

    const [selectedApplication, setCurrentApplication] = useState(null);
    const [selectedProfileResume, setCurrentResume] = useState(null);
    const [selectedJD, setCurrentJd] = useState(null);
    const [applicationError, setLinkApplicationError] = useState("");
    const [currentCandidatestatus, setCurrentCandidateStatus] = useState(linkedApplication?.candidatestatus?.status);

    function UseEffectConsdition(){
        var status = false
        if((linkedApplication == null) || (linkedProfileResume == null))
        {
           status = true
        }
        if(linkedApplicationError != "")
        {
            status = false
        }
        
        return status
    }
    useEffect(() => {
        if( linkedApplicationError == ""){
            getLinkedApplicationByJD(qhoid,jdID,"0",resumeID) 
            getLinkedProfileResumeDetails (qhoid,"0",jdID,resumeID)
            setCurrentApplication(linkedApplication)
            setCurrentResume(linkedProfileResume)
            setCurrentCandidateStatus(selectedApplication?.candidatestatus.status)
            setCurrentJd(linkedJd)
            setLinkApplicationError("")
        }
        if( linkedApplicationError != ""){
            setLinkApplicationError(linkedApplicationError)
            setCurrentJd(linkedJd)
        }

    }, [UseEffectConsdition()]);


    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    function getRequirementType(){
        if(selectedApplication?.reqtype == "customer_project" ){
            if(selectedApplication?.positiontype == "TP"){
                return true
            }
        }
        return false
    }

    function setCandidateStatus(e){
        console.log(e)
        switch (e.target.value){
            case "Our": {
                setCurrentCandidateStatus("Available")
            }
            break;
            case "End Client":{
                setCurrentCandidateStatus("Direct Payroll")
            }
            break;
            case "Client":{
                setCurrentCandidateStatus("Direct Payroll")
            }
            break;
            case "Interview within 6 months": {
                setCurrentCandidateStatus("Interview within 6 months")
            }
            break;
            case "Interview before 6 months":{
                setCurrentCandidateStatus("Interview before 6 months")
            }
            break;
            case "Already Got Call":{
                setCurrentCandidateStatus("Already Got Call")
            }
            break;
            case "Already Applied":{
                setCurrentCandidateStatus("Already Applied")            
            }
            break;                         
        }
    }

    const encodeApplicationJson = (values) =>{

        let encodedJsonValues ={};
        //FSM to maintain the JD state
        encodedJsonValues.applicationstatus = "Processing"
        //get company details
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        encodedJsonValues.qhoid= userData.qhoid;
        encodedJsonValues.accounttype= userData.account_type ;
        encodedJsonValues.qhrid= resumeID;
        encodedJsonValues.qhcompanyjid= jdID
        encodedJsonValues.version= "1.0"
        encodedJsonValues._id ="Not Needed Only Dummy"

        //now fill the parameters
        encodedJsonValues.applicationid ={};
        encodedJsonValues.applicationid.name=values.name;
        encodedJsonValues.applicationid.email=values.email;
        encodedJsonValues.applicationid.mobile=values.mobile;
        encodedJsonValues.applicationid.aadharid=values.aadharid;


        encodedJsonValues.newemploymentdetails ={};
        encodedJsonValues.newemploymentdetails.preferredlocation=[];

        encodedJsonValues.newemploymentdetails.preferredlocation=values.preferredlocation;
        encodedJsonValues.newemploymentdetails.locationchangereason=values.locationchangereason;
        encodedJsonValues.newemploymentdetails.ectc={}
        encodedJsonValues.newemploymentdetails.ectc.totalctc= values.ectc;   
        encodedJsonValues.newemploymentdetails.ectc.ctcremarks =  values.ctcremarks;   
        encodedJsonValues.newemploymentdetails.payroll = values.payroll;  
        encodedJsonValues.newemploymentdetails.relevantexp = values.relevantexperience;
        encodedJsonValues.newemploymentdetails.totalexp = values.totalexperience;  
        encodedJsonValues.newemploymentdetails.appliedbefore = (values.candidatestatus == "Already Applied")? "Yes":"No";   
        encodedJsonValues.newemploymentdetails.alreadygotcall = (values.candidatestatus == "Already Got Call")? "Yes":"No"; 
    
        if(values.candidatestatus == "Interview before 6 months"){
            encodedJsonValues.newemploymentdetails.interviewgiven = "Interview before 6 months";
        }else if (values.candidatestatus == "Interview within 6 months"){
            encodedJsonValues.newemploymentdetails.interviewgiven = "Interview within 6 months";
        }else{
            encodedJsonValues.newemploymentdetails.interviewgiven = "No";
        }
        encodedJsonValues.newemploymentdetails.ectcoptions =  values.ectcoptions
        encodedJsonValues.newemploymentdetails.otherremarks =  values.otherremarks
 
        let newDate = getTimeNow()

        encodedJsonValues.sourcingdetails ={};
        encodedJsonValues.sourcingdetails.method= "By Candidate From Link"; 
        encodedJsonValues.sourcingdetails.teamdetails={}
        encodedJsonValues.sourcingdetails.teamdetails.qhuid= userData.qhuid;
        encodedJsonValues.sourcingdetails.teamdetails.name=userData.username; 
        encodedJsonValues.sourcingdetails.teamdetails.updatedon= newDate; 


        encodedJsonValues.candidatestatus ={};
        encodedJsonValues.candidatestatus.status= values.candidatestatus;
        encodedJsonValues.candidatestatus.updatedby={}
        encodedJsonValues.candidatestatus.updatedby.updatedon= newDate;
        encodedJsonValues.candidatestatus.updatedby.qhuid= userData.qhuid;

        encodedJsonValues.interviewstatus =null;
        encodedJsonValues.selectionstatus =null;        
        encodedJsonValues.skillsevalsatus =null;
        encodedJsonValues.testevalstatus =null;

        //now fill the parameters
        encodedJsonValues.employmentdetails ={};        
        encodedJsonValues.employmentdetails.currentcompany = values.currentcompany;
        encodedJsonValues.employmentdetails.designation = values.designation;
        encodedJsonValues.employmentdetails.currentlocation = values.currentlocation;
        encodedJsonValues.employmentdetails.currentctc = {};
        encodedJsonValues.employmentdetails.currentctc.totalctc = values.currentctc;
        encodedJsonValues.employmentdetails.noticeperiod = {};
        encodedJsonValues.employmentdetails.noticeperiod.officialnp = values.noticeperiod; 
        encodedJsonValues.employmentdetails.noticeperiod.isnegotiable = values.isnegotiable;  
        encodedJsonValues.employmentdetails.noticeperiod.negotiableto = values.negotiablenoticeperiod;
        encodedJsonValues.employmentdetails.noticeperiod.lwd = values.lwd;  
        encodedJsonValues.employmentdetails.noticeperiod.reason = values.reason;  

        encodedJsonValues.educationaldetail ={}; 
        encodedJsonValues.educationaldetail.maxdegree=values.maxdegree;
        encodedJsonValues.educationaldetail.stream= values.stream;
        encodedJsonValues.educationaldetail.college= values.college;
        encodedJsonValues.educationaldetail.percentage= values.percentage;              


        encodedJsonValues.personaldetail ={};
        encodedJsonValues.personaldetail.name= values.name;
        encodedJsonValues.personaldetail.email= values.email;
        encodedJsonValues.personaldetail.mobile= values.mobile;
        encodedJsonValues.personaldetail.aadharid= values.aadharnumber;
        encodedJsonValues.personaldetail.dob= values.dob;
        encodedJsonValues.personaldetail.gender= values.gender;  
        //encodedJsonValues.personaldetail.age= values.age;      
        //encodedJsonValues.personaldetail.martialstatus= values.martialstatus;    

        encodedJsonValues.offerdetails={}
        encodedJsonValues.offerdetails.otheroffer = values.otheroffer;
        encodedJsonValues.offerdetails.offerctc = values.offerctc;
        encodedJsonValues.offerdetails.offerdoj = values.offerdoj;  
        encodedJsonValues.offerdetails.offercompanytype  =   value.offercompanytype
        encodedJsonValues.offerdetails.offerlocations = values.offerlocations;
        encodedJsonValues.offerdetails.whyjoinus =   value.whyjoinus        
        
        return encodedJsonValues
    }

    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }

    const handleOffer = (e) => {
        if(e.target.value == "No Offer"){
          setOffersGot(false);
        }else if (e.target.value == "In Pipeline") {
          setOffersGot(true);
        }else {
          setOffersGot(true);
        }      
    };    

    const handleFormSubmit = (values) => {
        const jasonValues = encodeApplicationJson(values)
        updateProfileInLinkedApplication({
            jasonValues,jdID,resumeID
        });
        message.success("Application Successfully Submitted");
    };    

  const handleFormSubmitError = (values) => {
    message.success("Something is wrong. No JDID");
    setCurrentView("assignment");
};

  const appvalues ={
    name: selectedProfileResume?.personaldetail.name,
    email: selectedProfileResume?.personaldetail.email,
    mobile: selectedProfileResume?.personaldetail.mobile,
    candidatestatus: selectedApplication?.candidatestatus.status,
    currentlocation: selectedProfileResume?.employmentdetails.currentlocation,
    preferredlocation: selectedApplication?.newemploymentdetails.preferredlocation,
    locationchangereason: selectedApplication?.newemploymentdetails.locationchangereason,
    maxdegree: selectedProfileResume?.educationaldetail.maxdegree,
    stream: selectedProfileResume?.educationaldetail.stream,
    college: selectedProfileResume?.educationaldetail.college,
    designation: selectedProfileResume?.employmentdetails.designation,
    totalexperience: selectedApplication?.newemploymentdetails.totalexp,
    relevantexperience: selectedApplication?.newemploymentdetails.relevantexp,
    currentcompany: selectedProfileResume?.employmentdetails.currentcompany,
    noticeperiod: selectedProfileResume?.employmentdetails.noticeperiod.officialnp== 1024?"":
                  selectedProfileResume?.employmentdetails.noticeperiod.officialnp,
    negotiablenoticeperiod: selectedProfileResume?.employmentdetails.noticeperiod.negotiableto ==1024?"":
                  selectedProfileResume?.employmentdetails.noticeperiod.negotiableto,
    lwd: selectedProfileResume?.employmentdetails.noticeperiod.lwd,
    reason: selectedProfileResume?.employmentdetails.noticeperiod.reason,
    currentctc: selectedProfileResume?.employmentdetails.currentctc.totalctc,
    ectc: selectedApplication?.newemploymentdetails.ectc.totalctc,
    ectcoptions: selectedApplication?.newemploymentdetails.ectcoptions,
    ctcremarks: selectedApplication?.newemploymentdetails.ctcremarks,
    otheroffer: selectedProfileResume?.offerdetails.otheroffer,
    offercompanytype: selectedProfileResume?.offerdetails.offercompanytype,   
    offerctc: selectedProfileResume?.offerdetails.offerctc,
    offerdoj: selectedProfileResume?.offerdetails.offerdoj,
    aadharnumber: selectedApplication?.applicationid.aadharid,
    otherremarks: selectedApplication?.newemploymentdetails.otherremarks ,
    dob: selectedProfileResume?.personaldetail.dob,
    gender: selectedProfileResume?.personaldetail.gender
  }

    return (
            <div className="jobApplication-summary-wrapper">
            <div className="jobApplication-header-wrapper">
                {
                    selectedJD != null?
                      <>
                        <div className ="jobApplication-heading"> Jop Opening for {selectedJD?.JDDetails.Title} </div> 
                        <div className ="jobApplication-heading-role-desc"> Application Form for the Role of  </div>
                        <div className ="jobApplication-heading-role"> {selectedJD?.JDDetails.Designation} </div>                       
                      </>
                      :<></>
                }  
                   <div className ="jobApplication-Qh-branding">
                        Autogenerated from &nbsp;
                        <a href="https://quallyhireai.com">Quallyhire.AI</a>
                   </div>
            </div>                      
            <div className="profile-creation-form-wrapper">
                <div className="jobApplication-section-header"> Please provide below details {appvalues?.name} </div>  
            {
                selectedApplication != null?
                <>
                <Form
                    key={formKey}
                    className="profile-creation-form"
                    name="profile-creation-form"
                    justify="start"
                    layout="vertical"
                    autoComplete="off"
                    onFinish={value ? handleFormSubmit : handleFormSubmitError}
                    initialValues={appvalues}
                >
                    <div className="triple-input-wrapper">
                        <Form.Item
                            required={value ? false : true}
                            className="jd-creation-field-item"
                            label="Candidate Name"
                            name="name"
                        >
                            <Input
                                disabled={!isEditMode}
                                required={value ? false : true}
                                className="jd-creation-input"
                                name="name"
                            />
                        </Form.Item>

                        <Form.Item
                            required={value ? false : true}
                            className="jd-creation-field-item"
                            label="Email ID"
                            name="email"
                        >
                            <Input
                                disabled={true}
                                required={value ? false : true}
                                className="jd-creation-input"
                            />
                        </Form.Item>
                        <Form.Item
                                required={value ? false : true}
                                name="mobile"
                                className="jd-creation-field-item"
                                label="Mobile Number"
                            >
                                <Input
                                    disabled={!isEditMode}
                                    required={value ? false : true}
                                    className="jd-creation-input"
                                />
                        </Form.Item>
                    </div>
                    <Form.Item
                            required={isRequired}
                            name="candidatestatus"
                            className="jd-creation-field-item"
                            label="Check Candidate Application Status"
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                className="jd-creation-radio-wrapper-4"
                                name="candidatestatus"
                                onChange = {setCandidateStatus}
                            >
                                <Radio className="radio-option" value={"Available"}>
                                    First Time Applying
                                </Radio>
                                <Radio className="radio-option" value={"Already Got Call"}>
                                Already got call from other Vendor
                                </Radio>                            
                                <Radio className="radio-option" value={"Already Applied"}>
                                    Applied before already
                                </Radio>
                                <Radio className="radio-option" value={"Interview within 6 months"}>
                                    Given Interview, within 6 months
                                </Radio>
                                <Radio className="radio-option" value={"Interview before 6 months"}>
                                    Given Interview, Before 6 months
                                </Radio>
                            </Radio.Group>
                    </Form.Item> 

                    <div className="triple-input-wrapper">
                        <Form.Item
                            required={value ? false : true}
                            name="currentlocation"
                            className="jd-creation-field-item"
                            label="Current Location"
                        >
                            <Input
                                disabled={!isEditMode}
                                required={value ? false : true}
                                className="jd-creation-input"
                            />
                        </Form.Item> 
                        <Form.Item
                            required={value ? false : true}
                            name="currentcompany"
                            className="jd-creation-field-item"
                            label="Current Company"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                required={value ? false : true}
                                className="jd-creation-input"
                            />
                        </Form.Item>

                        <Form.Item
                            required={isRequired}
                            name="designation"
                            className="jd-creation-field-item"
                            label="Current Designation"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                required={value ? false : true}
                                className="jd-creation-input"
                            />
                        </Form.Item>

                                            
                    </div>

                    <div className="triple-input-wrapper">

                        <Form.Item
                            required={value ? false : true}
                            name="currentctc"
                            className="jd-creation-field-item"
                            label="Current CTC (LPA)"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                required={isRequired}
                                className="jd-creation-input"
                            />                       
                        </Form.Item> 
                        <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Total Exp Yrs"
                            name="totalexperience"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="number"
                                name="totalexperience"
                                placeholder={"x.y"}
                                required={isRequired}
                                className="jd-creation-input"
                            />  
                        </Form.Item>  

                        <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Relevant Exp (Yrs)"
                            name="relevantexperience"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="number"
                                placeholder={"x.y"}
                                required={isRequired}
                                className="jd-creation-input"
                            /> 
                        </Form.Item>                     
                    </div>
                                
                    <div className="triple-input-wrapper">                  

                    <Form.Item
                            className="jd-creation-field-item"
                            label="LWD"
                            name="lwd"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                required={isRequired}
                                className="jd-creation-input"
                            />

                        </Form.Item> 
                        <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Official Notice Period (Days)"
                            name="noticeperiod"
                        >
                        <Select
                                disabled={!isEditMode}
                                placeholder="Please select"                                
                                required={isRequired}
                                className="jd-creation-input"                            
                                options={[
                                    { value: 0, label: 0 },                                
                                    { value: 15, label: 15 },
                                    { value: 30, label: 30 },
                                    { value: 45, label: 45 },
                                    { value: 60, label: 60 },
                                    { value: 90, label: 90},
                                    { value: 120, label: 120 },
                                    { value: 180, label: 180 },
                                ]}
                        />                          
                        </Form.Item>
                        <Form.Item
                            required={isRequired}
                            className="jd-creation-field-item"
                            label="Negotiable Notice Period (Days)"
                            name="negotiablenoticeperiod"
                        >
                        <Select
                                disabled={!isEditMode}
                                placeholder="Please select"                                
                                required={isRequired}
                                className="jd-creation-input"                            
                                options={[
                                    { value: 0, label: 0 },
                                    { value: 5, label: 5 },
                                    { value: 10, label: 10 },
                                    { value: 15, label: 15 },
                                    { value: 30, label: 30 },
                                    { value: 45, label: 45 },
                                    { value: 60, label: 60 },
                                    { value: 90, label: 90},
                                    { value: 120, label: 120 },
                                    { value: 180, label: 180 },
                                ]}
                        /> 
                        </Form.Item>                    
                    </div>

                    <div className="triple-input-wrapper">
                        <Form.Item
                            required={isRequired}
                            name="preferredlocation"
                            className="jd-creation-field-item"
                            label="Preferred Locations"
                        >
                                <Select
                                    disabled={!isEditMode}
                                    mode="multiple"
                                    allowClear
                                    placeholder="Please select"                                
                                    required={value ? false : true}
                                    className="jd-creation-input"                            
                                    options={[
                                        { value: 'Bengaluru', label: 'Bengaluru' },
                                        { value: 'Chennai', label: 'Chennai' },
                                        { value: 'Hyderabad', label: 'Hyderabad' },
                                        { value: 'Gurgaon', label: 'Gurgaon' },
                                        { value: 'Noida', label: 'Noida'},
                                        { value: 'Delhi', label: 'Delhi' },
                                        { value: 'Mumbai', label: 'Mumbai' },
                                        { value: 'Pune', label: 'Pune' },
                                        { value: 'Kolkata', label: 'Kolkata' },
                                        { value: 'Nagpur', label: 'Nagpur'},
                                        { value: 'Madurai', label: 'Madurai'}, 
                                        { value: 'Remote', label: 'Remote ' },
                                        { value: 'Other', label: 'Other' },
                                        { value: 'Abroad', label: 'Abroad' }, 
                                    ]}
                                />                         
                        </Form.Item>

                        <Form.Item
                            required={value ? false : true}
                            name="locationchangereason"
                            className="jd-creation-field-item"
                            label="Relocation Reason"
                        >
                                <Select
                                    disabled={!isEditMode}
                                    placeholder="Please Select"                                
                                    required={value ? false : true}
                                    className="jd-creation-input"                            
                                    options={[
                                        { value: 'NA', label: 'NA' },
                                        { value: 'Partner Job', label: 'Partner Job' },
                                        { value: 'Family Member Lives there', label: 'Family Member Lives there' },
                                        { value: 'Carrer Growth', label: 'Carrer Growth' },
                                        { value: 'Other Reasons', label: 'Other Reasons'},
                                    ]}
                                />                         
                        </Form.Item>

                        <Form.Item
                            required={value ? false : true}
                            className="jd-creation-field-item"
                            label="Reason for Leaving "
                            name="reason"
                        >
                        <Select
                                disabled={!isEditMode}
                                placeholder="Please select"                                
                                required={value ? false : true}
                                className="jd-creation-input"                            
                                options={[
                                    { value: "No Project,On Bench", label: "No Project,On Bench"},                                
                                    { value: "LayOff", label: "LayOff" },
                                    { value: "Financial Growth", label: "Financial Growth" },
                                    { value: "No JobSatisfaction", label: "No JobSatisfaction" },
                                    { value: "Poor Work Environment", label: "Poor Work Environment" },
                                    { value: "Persoanl Reason", label: "Persoanl Reason"},
                                    { value: "To Take care of family", label: "To Take care of family" },
                                    { value: "Othe reasons" ,label: "Othe reasons" },
                                ]}
                        />                          
                        </Form.Item> 
                                                    
                    </div>                
                    <div className="triple-input-wrapper">
                        <Form.Item
                            required={value ? false : true}
                            name="ectc"
                            className="jd-creation-field-item"
                            label="ECTC (LPA)"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                required={value ? false : true}
                                className="jd-creation-input"
                            />                       
                        </Form.Item>                                                        
                        <Form.Item
                            required={isRequired}
                            name="ectcoptions"
                            className="jd-creation-field-item"
                            label="ECTC Options"
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                className="jd-creation-radio-wrapper-3"
                            >
                                <Radio className="radio-option" value={"Negotiable"}>
                                    Negotiable
                                </Radio>
                                <Radio className="radio-option" value={"Fixed"}>
                                    Fixed
                                </Radio>                            
                                <Radio className="radio-option" value={"Will Discuss with HR"}>
                                    Will discuss with HR
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            required={isRequired}
                            name="otheroffer"
                            className="jd-creation-field-item"
                            label="Other offers"
                            onChange = {handleOffer}
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                className="jd-creation-radio-wrapper-4"
                            >
                                <Radio className="radio-option" value={"No Offer"}>
                                    No Offer
                                </Radio>                           
                                <Radio className="radio-option" value={"One Offer"}>
                                    One Offer
                                </Radio>
                                <Radio className="radio-option" value={"Multiple Offer"}>
                                    Multiple offer
                                </Radio>
                                <Radio className="radio-option" value={"In Pipeline"}>
                                    In Pipeline
                                </Radio>                            
                            </Radio.Group>
                        </Form.Item>                     
                    </div>
                    {
                        haveOtherOffer ?
                        <>
                    <div className="triple-input-wrapper">
                            <Form.Item
                                name="offercompanytype"
                                className="jd-creation-field-item"
                                label="Other offer Company type"
                            >
                                <Radio.Group
                                    disabled={!isEditMode}
                                    className="jd-creation-radio-wrapper"
                                >
                                    <Radio className="radio-option" value={"Product"}>
                                        Product
                                    </Radio>
                                    <Radio className="radio-option" value={"Service"}>
                                        Service
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>                      
                            <Form.Item
                                name="offerctc"
                                className="jd-creation-field-item"
                                label="Other Offer CTC (LPA)"
                            >
                                <Input
                                    disabled={!isEditMode}
                                    type="text"
                                    className="jd-creation-input"
                                />                       
                            </Form.Item> 
                            <Form.Item
                                name="offerlocations"
                                className="jd-creation-field-item"
                                label="Other Offer Location"
                            >
                                <Input
                                    disabled={!isEditMode}
                                    type="text"
                                    className="jd-creation-input"
                                />                       
                            </Form.Item>                     
                    </div>                        
                    <div className="triple-input-wrapper">
                        <Form.Item
                            name="offerdoj"
                            className="jd-creation-field-item"
                            label="Other Offer DoJ"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                className="jd-creation-input"
                            />                       
                        </Form.Item> 
                        <Form.Item
                            name="offercompany"
                            className="jd-creation-field-item"
                            label="Other Offer Company Names"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                className="jd-creation-input"
                            />                       
                        </Form.Item> 
                        <Form.Item
                            name="whyjoinus" 
                            className="jd-creation-field-item"
                            label="Why Would you Join Us"
                        >
                            <Input
                                disabled={!isEditMode}
                                type="text"
                                className="jd-creation-input"
                            />                       
                        </Form.Item>                                                                                                   
                    </div>                         
                        </>
                        :<></>
                    }
                   
                <div className="triple-input-wrapper">
                    <Form.Item
                                required={isRequired}
                                name="maxdegree"
                                className="jd-creation-field-item"
                                label="Max Degree"
                            >
                                <Select
                                    disabled={!isEditMode}
                                    placeholder="Please select"                                
                                    required={isRequired}
                                    className="jd-creation-input"                            
                                    options={[
                                        { value: 'BE', label: 'BE' },
                                        { value: 'BTech', label: 'BTech' },
                                        { value: 'ME', label: 'ME' },
                                        { value: 'MTech', label: 'MTech' },
                                        { value: 'PhD', label: 'PhD'},
                                        { value: 'BCA', label: 'BCA'},
                                        { value: 'MCA', label: 'MCA'},
                                        { value: 'Diploma', label: 'Diploma'},
                                        { value: 'BCom', label: 'BCom'},
                                        { value: 'MCom', label: 'MCom'},
                                        { value: 'BEd', label: 'BEd'},
                                        { value: 'MEd', label: 'MEd'},
                                        { value: 'BSc', label: 'BSc'},
                                        { value: 'MSc', label: 'MSc'},
                                        { value: 'MBBS', label: 'MBBS'},
                                        { value: 'MD/MS', label: 'MD/MS'},
                                        { value: 'MS (Abroad)', label: 'MS (Abroad)'},
                                        { value: 'BS (Abroad)', label: 'BS (Abroad)'},
                                        { value: 'PhD (Abroad)', label: 'PhD (Abroad)'},                                                                        
                                    ]}
                                /> 
                    </Form.Item>                        
                    <Form.Item                            
                            name="yearofpassing"
                            className="jd-creation-field-item"
                            label="Year of Passing"
                            required={isRequired}
                        >
                            <Input
                                disabled={!isEditMode}                             
                                required={isRequired}
                                className="jd-creation-input"
                            />
                    </Form.Item>                     

                    <Form.Item
                            
                            name="college"
                            className="jd-creation-field-item"
                            label="Uni/College"
                        >
                            <Select
                                disabled={!isEditMode}
                                placeholder="Please select"                                                               
                                className="jd-creation-input"                            
                                options={[
                                    { value: 'IIT', label: 'IITs' },
                                    { value: 'IIM', label: 'IIMs' },
                                    { value: 'REC', label: 'RECs' },
                                    { value: 'JNTU', label: 'JNTU' },
                                    { value: 'Govt College', label: 'Govt College' },
                                    { value: 'Private College', label: 'Private College' },
                                    { value: 'AIIMS', label: 'AIIMS' },                                    
                                    { value: 'Foreign', label: 'Foreign'},
                                    { value: 'Others', label: 'Others'},
                                ]}
                            />  
                    </Form.Item> 
                                                         
                </div>   
                <div className="triple-input-wrapper">
                <Form.Item
                            
                            name="stream"
                            className="jd-creation-field-item"
                            label="Stream"
                        >
                            <Input
                                disabled={!isEditMode}
                                
                                className="jd-creation-input"
                            />
                    </Form.Item>    
                    <Form.Item
                        name="percentage"
                        className="jd-creation-field-item"
                        label="Percentage/CGPA of Max Degree"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input" 
                        />
                    </Form.Item>
                </div>                                               
                <div className="triple-input-wrapper">
                    <Form.Item
                        name="aadharnumber"
                        className="jd-creation-field-item"
                        label="Aadhar Number"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input"
                        />
                    </Form.Item>
                    <Form.Item
                        name="dob"
                        className="jd-creation-field-item"
                        label="DoB"
                    >
                        <Input
                            disabled={!isEditMode}
                            className="jd-creation-input"
                            placeholder="dd/mm/yyyy" 
                        />
                    </Form.Item>
                    <Form.Item
                        name="gender"
                        className="jd-creation-field-item"
                        label=" Gender"
                    >
                        <Radio.Group
                            disabled={!isEditMode}
                            className="jd-creation-radio-wrapper"
                        >
                            <Radio className="radio-option" value={"Male"}>
                                Male
                            </Radio>
                            <Radio className="radio-option" value={"Female"}>
                                Female
                            </Radio>
                        </Radio.Group>                        
                    </Form.Item>
                </div>


                <Form.Item
                    name="otherremarks"
                    className="jd-creation-field-item"
                    label="Other Remarks"
                >
                    <Input
                        disabled={!isEditMode}
                        type="text"
                        className="jd-creation-input"
                    />                       
                </Form.Item>   

                    <Button
                        style={{ width: "100%", height: "40px", fontWeight: "600" }}
                        type="primary"
                        disabled={!isEditMode}
                        htmlType="submit"
                    >
                        Submit Details
                    </Button>
                </Form>                    
                </>
                :applicationError != ""?
                <>
                  {applicationError}
                </>
                :<>
                </>
            }                                                                    
     
            </div>

            <div className="jobApplication-footer">
                Disclaimer: Submission of this form does not guarantee job for this position. This form is just for collection of your information
                and submitting your profile for this position. Based on the information provided, your profile will be screened from the recruiter.
                <br></br>
                <a href="https://quallyhireai.com">Quallyhire.AI</a> &nbsp; &copy;2025
            </div>
        </div>
    );
}
